import React from "react";

export default function DisruptorD(props: React.SVGProps<any>) {
  return (
    <svg width={80} height={80} viewBox="0 0 80 80" {...props}>
      <defs>
        <linearGradient x1="0%" y1="50%" x2="156.67%" y2="50%" id="sakj4209sa0r">
          <stop stopColor="#7962FF" offset="0%" />
          <stop stopColor="#E87BB1" offset="100%" />
        </linearGradient>
      </defs>

      <g fill="none" fillRule="evenodd">
        <path
          d="M40 0c22.063 0 40 17.937 40 40S62.063 80 40 80 0 62.063 0 40 17.937 0 40 0z"
          fill="url(#sakj4209sa0r)"
        />
        <path
          d="M39.805 55c9.405 0 15.93-5.94 15.93-14.985 0-9.045-6.525-15.03-15.93-15.03H27.97V55h11.835zm0-5.625H34.36V30.61h5.445c6.165 0 9.405 4.095 9.405 9.405 0 5.085-3.465 9.36-9.405 9.36z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}
